__turbopack_context__.v({
  "bottom-center": "Toast-module-scss-module__t3p9VW__bottom-center",
  "bottom-left": "Toast-module-scss-module__t3p9VW__bottom-left",
  "bottom-right": "Toast-module-scss-module__t3p9VW__bottom-right",
  "closeButton": "Toast-module-scss-module__t3p9VW__closeButton",
  "content": "Toast-module-scss-module__t3p9VW__content",
  "toast": "Toast-module-scss-module__t3p9VW__toast",
  "top-center": "Toast-module-scss-module__t3p9VW__top-center",
  "top-left": "Toast-module-scss-module__t3p9VW__top-left",
  "top-right": "Toast-module-scss-module__t3p9VW__top-right",
  "visible": "Toast-module-scss-module__t3p9VW__visible",
});
